import * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';
export { default as SkypeNotificationOption } from './SkypeNotificationOption';
export { default as SkypeNotificationType } from './data/store/schema/SkypeNotificationType';
export {
    NotificationSettingType,
    NotificationAllowedValue,
    ISettingsNotificationOption,
    convertOwsSettingTypeToSwc,
} from './utils/swcNotificationUtils';
export { default as getSwcSettings } from './data/store/swcStore';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(
        /* webpackChunkName: "SkypeOptions", webpackPrefetch: true */ './lazyIndex'
    )
);

export const lazyInitializeNotificationSettings = new LazyAction(
    lazyModule,
    m => m.initializeNotificationSettings
);
